import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWikiPrimary = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3068 11.6135V19.1708C9.18678 18.8241 6.76013 16.1894 6.76013 13.0001C6.76013 11.1281 7.59211 9.3948 8.9788 8.28543L12.3068 11.6135Z",
			fill: "#40BAEC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2401 13.0001C19.2401 16.1894 16.8134 18.8934 13.6934 19.1708V11.6135L17.0214 8.28543C18.4081 9.3948 19.2401 11.1281 19.2401 13.0001Z",
			fill: "#40BAEC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0028 5.30412L18.0614 7.2454C19.6561 8.63209 20.6268 10.7121 20.6268 13.0001C20.6268 17.2294 17.2294 20.6267 13.0001 20.6267C8.77076 20.6267 5.37343 17.2294 5.37343 13.0001C5.37343 10.7121 6.41345 8.70143 7.93878 7.2454L5.99743 5.30412C3.91745 7.2454 2.6001 9.94943 2.6001 13.0001C2.6001 18.7547 7.24543 23.4 13.0001 23.4C18.7548 23.4 23.4001 18.7547 23.4001 13.0001C23.4001 9.94943 22.0828 7.2454 20.0028 5.30412Z",
			fill: "#40BAEC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0001 9.53342C14.9146 9.53342 16.4667 7.98133 16.4667 6.06676C16.4667 4.15219 14.9146 2.6001 13.0001 2.6001C11.0855 2.6001 9.53338 4.15219 9.53338 6.06676C9.53338 7.98133 11.0855 9.53342 13.0001 9.53342Z",
			fill: "#40BAEC"
		})
	]
});
export default SvgWikiPrimary;
